export default "__VITE_ASSET__0a7a09a9__"